import { apiRequest } from "util/services";

/** MCP Pro status, limits and this month's usage for the user's organization. */
export const fetchMcpProStatus = () =>
  apiRequest("mcp/pro/status", "GET", null, true);

/** What the consent page shows for an OAuth authorize request (client, redirect host, MCP Pro). */
export const fetchOauthConsentInfo = (params) =>
  apiRequest(`oauth/consent-info?${new URLSearchParams(params).toString()}`, "GET", null, true);

/** Approve the request; the answer carries the redirect_url back to the client. */
export const approveOauthRequest = (params) =>
  apiRequest("oauth/approve", "POST", params, true);
